import * as Sentry from "@sentry/capacitor";
import * as SentryReact from "@sentry/react";
import { VITE_SENTRY_ENVIRONMENT, VITE_SENTRY_DSN } from "@/lib/utils/config";
import { getAppInfo } from "@/lib/utils/app-info";

const initSentry = async (): Promise<void> => {
  const appInfo = await getAppInfo();

  const tracesSampleRate = 0.01; // 1%
  const replaysOnErrorSampleRate = VITE_SENTRY_ENVIRONMENT === "production" ? 1.0 : 0; // 100% ou 0%

  const replay = SentryReact.replayIntegration({
    maskAllText: false,
    blockAllMedia: true,
  });

  const feedback = SentryReact.feedbackIntegration({
    colorScheme: "light",
    themeLight: {
      accentBackground: "#00658a",
    },
    showBranding: false,
    useSentryUser: {
      email: "email",
      name: "fullName",
    },
    autoInject: false,
    showName: false,
    showEmail: false,
    formTitle: "Nos ajude a melhorar!",
    submitButtonLabel: "Enviar Feedback",
    cancelButtonLabel: "Cancelar",
    triggerLabel: "Enviar Feedback",
    enableScreenshot: false,
    nameLabel: "Nome",
    namePlaceholder: "Seu nome",
    emailLabel: "Email",
    emailPlaceholder: "",
    isRequiredLabel: "(obrigatório)",
    messageLabel: "Descrição",
    messagePlaceholder: "Deixe aqui o seu feedback.",
    successMessageText: "Obrigado por nos ajudar!",
  });

  Sentry.init(
    {
      environment: VITE_SENTRY_ENVIRONMENT,
      dsn: VITE_SENTRY_DSN,
      release: `${appInfo.id}@${appInfo.version}+${appInfo.build}`,
      dist: appInfo.version,
      enableAutoSessionTracking: true,
      integrations: [replay, feedback],
      tracesSampleRate,
      // Session Replay
      replaysSessionSampleRate: 0.01, // 1%
      replaysOnErrorSampleRate,
      tracePropagationTargets: [
        "localhost",
        "https://hasura.livance.com.br",
        "https://app.livance.com.br",
        "https://painel.livance.com.br",
      ],
      debug: false,
      beforeSend(event, _hint) {
        // Filtrar erros de SyntaxError "Unexpected EOF" relacionados ao CapGo
        if (
          event.exception?.values?.[0]?.type === "SyntaxError" &&
          event.exception.values[0].value?.includes("Unexpected EOF")
        ) {
          return null; // Ignora o erro
        }

        return event;
      },
    },
    SentryReact.init,
  );
};

export { initSentry, Sentry };
